<template>
  <div>
    <p>Your account is awaiting approval.</p>
    <p>
      A Maintenance Manager is reviewing your request and you will be emailed
      when your account has been approved.
    </p>
  </div>
</template>

<script>
export default {
  name: "AwaitingApproval",
};
</script>

<style lang="scss" scoped>
</style>